module.exports = __webpack_public_path__ + "img/02-04-img-03@2x.7b4a5031.png";